import { useState } from "react";

type Item = {
  _id: string | number;
};

type UseSelectCheckboxReturn = {
  selectList: (string | number)[];
  handleSelectCheckbox: (item: Item) => void;
  isSelected: (item: Item) => boolean;
  selectAll: (data: Item[]) => void;
  clear: () => void;
};

/**
 * 체크박스 선택 및 전체 선택 Hook
 */
const useSelectCheckbox = (): UseSelectCheckboxReturn => {
  const [selectList, setSelectList] = useState<(string | number)[]>([]);

  const handleSelectCheckbox = (item: Item) => {
    if (item._id) {
      setSelectList((prev) =>
        prev.includes(item._id)
          ? prev.filter((id) => id !== item._id)
          : [...prev, item._id]
      );
    }
  };

  const isSelected = (item: Item) => selectList.includes(item._id);

  const selectAll = (data: Item[]) => {
    setSelectList((prev) =>
      prev.length === data.length ? [] : data.map((item) => item._id)
    );
  };

  const clear = () => setSelectList([]);

  return {
    selectList,
    handleSelectCheckbox,
    isSelected,
    selectAll,
    clear,
  };
};

export default useSelectCheckbox;
